import { useToastStore } from './../store';
export var useToast = function () { return useToastStore().toast; };
//# sourceMappingURL=useToast.js.map